// The deal's path (TX-US-0043): Proposal, Approval, Contract, Execution and the
// outcome, drawn as the counterparty's onboarding path is (ui/PathStages.jsx). A passed stage
// opens what it holds (`?stage=`); choosing it again closes it.

import { useSearchParams } from 'react-router';

import PathStages from '../ui/PathStages.jsx';
import { pathOf } from './flow.js';

const STATE_WORDS = {
  done: 'passed',
  current: 'current',
  next: 'not reached',
  ended: 'where the deal ended',
  rejected: 'how the deal ended',
};

export default function StagePath({ deal, ended, open }) {
  const [searchParams] = useSearchParams();

  const stages = pathOf(deal, ended).map((stage) => ({
    ...stage,
    opens: stage.state === 'done' && stage.key !== 'OUTCOME' ? `what ${stage.label} holds` : null,
  }));

  const searchFor = (key) => {
    const next = new URLSearchParams(searchParams);
    if (key) next.set('stage', key);
    else next.delete('stage');
    return `?${next}`;
  };

  return (
    <div className="deal-path">
      <PathStages stages={stages} open={open} words={STATE_WORDS} searchFor={searchFor}
                  scrollKey={deal.stage} label="Stages" />
    </div>
  );
}
